<template>
  <div class="sales-follows">
    <portal to="layout-nav-title">{{ $t('model.reports/sales_follows') }}</portal>
    <el-form inline>
      <el-form-item label="统计时间" prop="start_on">
        <el-date-picker v-model="filter.start_on" type="month" value-format="yyyy-MM" />
      </el-form-item>
    </el-form>
    <TableList :start-on="filter.start_on" :users="users" />
  </div>
</template>

<script>
import { Vue, Component, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import TableList from './table-list.vue';
import Utils from '@/components/utils.vue';
import PerformanceRatesByYear from './performance_rates_by_year.vue';

@Component({
  components: {
    TableList,
  }
})
export default class SalesFollows extends Mixins(Vue, Utils) {
  filter = {
    start_on: moment().format('YYYY-MM'),
  };
  users = [];

  mounted() {
    this.fetchUsers();
  }

  async fetchUsers() {
    const data = await this.$request.get('/users/read_options', {
      page: 0,
      ...this.userOptionsFilter,
      id_eq: this.roleKind === 'salesman' || this.roleKind === 'customer_service' ? this.currentUser.id : undefined, // 业务员只能看自己的业绩
    });
    this.users = data;
  }
}

export const route = [
  {
    path: '/reports/sales_follows',
    component: {
      template: '<router-view />',
    },
    children: [
      {
        path: '',
        name: 'reports/sales_follows.index',
        component: SalesFollows,
        meta: {
          can: 'reports/sales_follows.read',
        },
      },
      {
        path: 'performance_rates_by_year',
        name: 'reports/sales_follows.performance_rates_by_year',
        component: PerformanceRatesByYear,
        meta: {
          can: 'reports/sales_follows.read',
        },
      }
    ],
  },
]
</script>

<style lang="scss" scoped>
.sales-follows {
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .button-group {
    display: flex;
  }
}
</style>

